import apinode from '../../apinode'

class ProdutosFilhosService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getItemsByProductSku(productSku) {
    const response = await apinode.get(`/filhos/${this.idconta}/${productSku}`)

    return response.data
  }

  async create(filhos, idFuncionario) {
    await apinode.post(`/filhos/${this.idconta}/${idFuncionario}`, {
      PRODUTOS_FILHOS: filhos,
    })
  }

  async updateLiberadoVenda(id, liberadovenda, idFuncionario) {
    await apinode.patch(`/filhos/${this.idconta}/${id}/${idFuncionario}`, {
      liberadovenda,
    })
  }

  async delete(id, idFuncionario) {
    await apinode.delete(`/filhos/${this.idconta}/${id}/${idFuncionario}`)
  }
}

export default new ProdutosFilhosService()
